import { Button, ButtonsGroup, Modal, ModalProps, useModal } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

type SendEInvoiceRequirementsModalFooterProps = Pick<ModalProps, 'id'> & {
  cancelInvoiceModalId: string
}

export const SendEInvoiceRequirementsModalFooter = ({
  cancelInvoiceModalId,
  id,
}: SendEInvoiceRequirementsModalFooterProps) => {
  const { t } = useTranslation()
  const { close: closeSendEInvoiceRequirementsModal } = useModal(id)
  const { open: openCancelInvoiceModal } = useModal(cancelInvoiceModalId)

  const handleCancelInvoiceButtonClick = () => {
    closeSendEInvoiceRequirementsModal()
    openCancelInvoiceModal()
  }
  const handleCloseButtonClick = () => {
    closeSendEInvoiceRequirementsModal()
  }

  return (
    <Modal.Footer>
      <ButtonsGroup>
        <Button variant="outlined" onClick={handleCancelInvoiceButtonClick}>
          {t('external_invoices.send_e_invoice_requirements.modal.footer.button.cancel_invoice')}
        </Button>
        <Button onClick={handleCloseButtonClick}>
          {t('external_invoices.send_e_invoice_requirements.modal.footer.button.close')}
        </Button>
      </ButtonsGroup>
    </Modal.Footer>
  )
}
